import * as React from "react";
import sideImage from "../../../assets/sample-image.png"
import crossedEye from "../../../assets/icons/crossed-eye.svg"
import eye from "../../../assets/icons/ShowView.svg"
import classes from './Login.module.scss'
import { Field, Form, Formik } from "formik";
import { LoginFormInitialValues, LoginFormValidation } from "../../../validations/AuthValidations";
import { Input } from "../../../components/Inputs/Input";
import { useState } from "react";
import { useLoader } from "../../../customHooks/loader";
import { useContext } from "react";
import { AuthContext } from "../../../context";
import { SET_USER } from "../../../constants";
import { UserService } from "../../../services/UserService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../../customHooks/cart";

export const Login = () => {
    const loader = useLoader();
    const navigate = useNavigate();
    const cart = useCart();
    const { refreshCart } = cart();

    const { dispatch: authDispatch } = useContext(AuthContext);
    const dispatchSetUser = (payload) => authDispatch({ type: SET_USER, payload });

    const [passwordInput, setPasswordInput] = useState('password');

    const handleLogin = async (values, resetForm) => {
        console.log({ values });
        try {
            const res = await UserService.login(values, loader);

            const { success } = res;

            if (success) {
                console.log({ first: res.data.user })
                dispatchSetUser({ user: res.data.user });
                refreshCart(res.data.cartItems);
                toast.success('Login Success');
            }
        } catch (error) {
            console.error(error);
        }
    }
    return (
        <>
            <div className={classes.parentContainer}>
                <img
                    src={sideImage}
                    alt="decorator"
                    className={classes.sideImage}
                />

                <div className={classes.div}>
                    <div className={classes.div2}>Welcome back!</div>
                    <Formik
                        enableReinitialize
                        initialValues={LoginFormInitialValues}
                        validationSchema={LoginFormValidation}
                        onSubmit={(val, { resetForm }) => handleLogin(val, resetForm)}
                    >
                        {({ errors, touched, values, isValidating, handleSubmit, ...props }) => {
                            return (
                                <Form>
                                    <div>
                                        <div className={classes.div3}>
                                            <Input name='email' type='email' placeholder='' labelClassName={classes.div3} label='Email address' className={classes.InputStyle} />
                                        </div>
                                        <div className={classes.div3}>
                                            <div className={classes.div11}>
                                                <label className={classes.div6} htmlFor='password'>Password</label>

                                                <div className={classes.div4}>
                                                    {passwordInput === 'password' ? (
                                                        <div onClick={() => setPasswordInput('text')} className={classes.password}>
                                                            <img
                                                                className={classes.img}
                                                                src={eye}
                                                                alt="hidden password"
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div onClick={() => setPasswordInput('password')} className={classes.password}>
                                                            <img
                                                                className={classes.img}
                                                                src={crossedEye}
                                                                alt="unhidden password"
                                                            />
                                                        </div>
                                                    )}

                                                </div>


                                            </div>
                                            <Field
                                                className={classes.InputStyle}
                                                type={passwordInput}
                                                name='password'
                                                id='password'
                                                placeholder='Password'
                                            />

                                            {errors.password && touched.password ? (
                                                <div className='error'>{errors.password}</div>
                                            ) : null}
                                        </div>
                                        <div className={classes.div9}>forgot password</div>
                                        <button type="submit" className={classes.div10}>Sign In</button>
                                    </div>
                                </Form>
                            )
                        }}
                    </Formik>
                    <div className={classes.div12}>Don't have an account? <span onClick={() => navigate('/register')}>Sign Up</span></div>
                </div>
            </div>
        </>
    );
}
